/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
const nameSpace = 'switchAccount'
export const SHOWDIALOG = `${nameSpace}_SHOWDIALOG`
export const CLOSEDIALOG = `${nameSpace}_CLOSEDIALOG`
export const VISABEL = `${nameSpace}_VISABEL`
export const DIALOGDATA = `${nameSpace}_DIALOGDATA`
export const SETDIALOGDATA = `${nameSpace}_SETDIALOGDATA`
